var exports = {
  "ZO": "MessageContextPrefix.module__channelHeader___bDVsRj",
  "wO": "MessageContextPrefix.module__channelHeaderCompact___bDVsRj",
  "p": "MessageContextPrefix.module__channelIcon___bDVsRj",
  "uS": "MessageContextPrefix.module__channelIconAvatar___bDVsRj",
  "bR": "MessageContextPrefix.module__channelIconAvatarImage___bDVsRj",
  "D4": "MessageContextPrefix.module__channelNameButton___bDVsRj",
  "Kw": "MessageContextPrefix.module__channelNameText___bDVsRj",
  "Vf": "MessageContextPrefix.module__channelNamePrimary___bDVsRj",
  "S4": "MessageContextPrefix.module__channelScopeRow___bDVsRj",
  "AQ": "MessageContextPrefix.module__channelScopeGuildIcon___bDVsRj",
  "oN": "MessageContextPrefix.module__channelScopeGuildName___bDVsRj",
  "V$": "MessageContextPrefix.module__channelScopeChevron___bDVsRj",
  "fm": "MessageContextPrefix.module__channelScopeChannelInfo___bDVsRj",
  "Gn": "MessageContextPrefix.module__channelScopeChannelIcon___bDVsRj",
  "wF": "MessageContextPrefix.module__channelScopeChannelName___bDVsRj",
  "bo": "MessageContextPrefix.module__focusRingTight___bDVsRj",
};

module.exports = exports;
